import { classNames } from 'primereact/utils';

import { SUFFIX_EMISSION_NUMERATOR } from '../../../../../../../../../../../../shared/constants/products.constant';
import { emissionValueWithDecimals } from '../../../../../../../../../../../../shared/helpers/emission-value-with-decimals';
import styles from '../../CalculationDetails.module.css';

type EmissionBreakdownValueCardProps = {
  title: string;
  value: number;
  color: string;
  index: number;
};

const EmissionsBreakdownValueCard = ({
  title,
  value,
  color,
  index,
}: EmissionBreakdownValueCardProps): JSX.Element | null => {
  if (!value) {
    return null;
  }

  return (
    <div
      className={classNames('col-6', {
        'pr-2': index % 2 === 0,
        'pl-2': index % 2 !== 0,
        'pb-3': index <= 1,
      })}
    >
      <div
        className={classNames(
          'p-4 border-round-2xl flex flex-row gap-3 align-items-center',
          styles['card'],
        )}
      >
        {/* Color */}
        <div
          className={classNames(
            'flex border-round-lg align-items-center',
            styles[`${color}-color-box`],
            styles['emission-breakdown'],
          )}
        />

        <div className='flex w-full flex-column'>
          <span className='font-medium text-lg'>{title}</span>

          <div className='flex flex-row gap-1 text-gray-700'>
            <span>{emissionValueWithDecimals(value)}</span>
            <span>{SUFFIX_EMISSION_NUMERATOR}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmissionsBreakdownValueCard;
